var _Circle, _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle, G, Path, Defs, ClipPath } from "react-native-svg";
var SvgIcDaySelect = function SvgIcDaySelect(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#BCBCBC",
    strokeWidth: 3,
    opacity: 0.5
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#ic_day_select_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#BCBCBC",
    d: "M25 19h-6v6h-2v-6h-6v-2h6v-6h2v6h6v2Z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "ic_day_select_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M6 6h24v24H6z"
  })))));
};
export default SvgIcDaySelect;